import React from 'react';
import styled from '@emotion/styled';

import { RetinaPicture } from 'client/components/RetinaPicture';
import { ImageType, ImageSizes } from './constants';
import { SCREEN_BREAKPOINTS } from '../../constants';

const QuoteImageContainer = styled.div`
  position: relative;
  width: 30%;
  height: 0;
  padding-bottom: 30.42%; // Ratio of SVG
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    margin: 0;
  }
`;

const QuoteRetinaPicture = styled(RetinaPicture)<{
  offset: number;
  size: ImageSizes;
  isHidden: boolean;
}>`
  position: absolute;
  top: 50%;
  left: ${({ offset }) => offset}%;
  z-index: 1;
  width: ${({ size }) => size[0]}px;
  height: ${({ size }) => size[0]}px;
  transform: translate(-${({ offset }) => offset}%, -50%);
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};
  img {
    width: 100%;
    height: 100%;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    width: ${({ size }) => size[1]}px;
    height: ${({ size }) => size[1]}px;
  }

  @media (max-width: 900px) {
    width: ${({ size }) => size[2]}px;
    height: ${({ size }) => size[2]}px;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    width: ${({ size }) => size[3]}px;
    height: ${({ size }) => size[3]}px;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    width: ${({ size }) => size[4]}px;
    height: ${({ size }) => size[4]}px;
  }

  @media (max-width: 340px) {
    width: ${({ size }) => size[5]}px;
    height: ${({ size }) => size[5]}px;
  }
`;

export const QuoteImage = ({
  image,
  isHidden,
}: {
  image: ImageType;
  isHidden: boolean;
}) => {
  return (
    <QuoteImageContainer>
      <QuoteRetinaPicture
        alt={image.alt}
        fallbackExtension={image.fallbackExtension}
        imagePath={image.imagePath}
        offset={image.offset}
        size={image.size}
        isHidden={isHidden}
      />
    </QuoteImageContainer>
  );
};
